import { render, staticRenderFns } from "./SolicitacoesAcessoDash.vue?vue&type=template&id=25578f5f&"
import script from "./SolicitacoesAcessoDash.vue?vue&type=script&lang=js&"
export * from "./SolicitacoesAcessoDash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports